import React, { useCallback, useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button/Button';

import {
  buildTeamAppTeamCalendlyUrl,
  buildUtmParams,
  calendlyUrlBuilderCommand,
} from 'features/calendlyEnterprise';

import CalendlyEnterpriseModal from 'components/CalendlyEnterpriseModal';
import { useCalendlyModalHandlers } from 'components/CalendlyModal/hooks';

import { toI18n } from 'util/i18n';

import { CLICK_TO_CALL_VIEW_KEY as VIEW_KEY } from '../constants';

import BillingSettingsAddonsCancellation from './customContents/BillingSettingsAddonsCancellation';
import CalendlyLink from './CalendlyLink';
import ModalViewTracker from './ModalViewTracker';
import { ViewType, ViewTypeProps } from './types';

export const customComponents = {
  billing_settings_addons_cancellation: BillingSettingsAddonsCancellation,
};

const OutsideBusinessHours: ViewType = ({
  utmContent,
  utmCampaign,
  currentUser,
  setDialogTitle,
  closeClickToCallDialog,
  customTitleOutsideBusinessHours,
  outsideBusinessHoursCustomComponentKey,
}: ViewTypeProps) => {
  const CustomComponent =
    outsideBusinessHoursCustomComponentKey &&
    customComponents[
      outsideBusinessHoursCustomComponentKey as keyof typeof customComponents
    ];

  const { calendlyModalIsOpen, handleCalendlyClick, handleCalendlyClose } =
    useCalendlyModalHandlers();

  useEffect(() => {
    setDialogTitle(
      customTitleOutsideBusinessHours ||
        toI18n('monetization.click_to_call.outside_business_hours.title')
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnClickPrimary = useCallback(() => {
    closeClickToCallDialog();
  }, [closeClickToCallDialog]);

  return (
    <ModalViewTracker viewName={VIEW_KEY.outside_business_hours}>
      {CustomComponent ? (
        <CustomComponent />
      ) : (
        <>
          <Box mb={24}>
            <Text variant="body">
              {toI18n(
                'monetization.click_to_call.outside_business_hours.subtitle'
              )}
            </Text>
          </Box>

          <CalendlyLink
            utmContent="manage_plan"
            onClickLink={handleCalendlyClick}
          />
        </>
      )}
      <Box hright>
        <Button onClick={handleOnClickPrimary}>
          {toI18n('monetization.click_to_call.outside_business_hours.cta')}
        </Button>
      </Box>
      <CalendlyEnterpriseModal
        open={calendlyModalIsOpen}
        origin="outside_business_hours"
        handleCloseModal={handleCalendlyClose}
        url={buildTeamAppTeamCalendlyUrl(
          calendlyUrlBuilderCommand({
            currentUser,
            queryParams: buildUtmParams(
              utmContent || 'manage_plan',
              utmCampaign || null
            ),
          })
        )}
      />
    </ModalViewTracker>
  );
};

export default OutsideBusinessHours;
